<template>
  <div class="expert-info wrap-content">
    <div class="wrap-inner">
      <div class="wrap-form">
        <Alert v-if="!dialog && !parentItems" show-icon banner>收集个人信息仅为支付评阅费用、报税使用，不会将信息泄露给第三方，请您务必填写并核实无误！</Alert>
        <Form :model="expertInfo" :label-width="120" ref="thesisEditForm" inline>
          <template v-for="(item,index) in formItems">
          <label v-if="item.isTitle" :key="index" class="form-label">{{item.label}}</label>
          <FormItem
              v-else
              :class="item.name"
              :key="item.name"
              :label="item.label + '：'"
              :prop="item.name"
              :rules="(readonly||item.readonly)?[]:item.rules">
            <component
                v-model="expertInfo[item.name]"
                :is="getDisplayComponent(item.component)"
                :ref="item.name"
                :str= item.str
                :type = item.type
                :readonly="readonly||item.readonly"
                :label="expertInfo[item.labelname] || expertInfo[item.name]"
                :label-prop="item.labelname"
                :placeholder ='item.placeholder'
                :options="item.options"
                @on-blur="changeInput(item)"
                @on-change="changeOnSelect(item)"
                @on-label-change="changeOnSelectForLabel">
            </component>
          </FormItem>
        </template>
        </Form>
        <div style="width:100%;display:flex;justify-content: center;align-items: center;margin-top:20px">
          <Button type="primary" @click="saveExpInfo" v-if="!dialog && !parentItems">保  存</Button>
        </div>
      </div>
      <Spin size="large" fix v-if="loading"></Spin>
    </div>
  </div>
</template>
<script>
import ElementInput from '@/components/elements/input'
import ElementSelect from '@/components/elements/select'
import ElementRadio from '@/components/elements/radio'
// import ElementBlock from '@/components/elements/block'

import ElementPhone from '@/components/defined/phone'
export default {
  // 专家信息
  name: 'expertInfo',
  components: {ElementInput, ElementSelect, ElementRadio, ElementPhone},
  props: ['dialog', 'dialogFrom', 'info', 'readonly', 'parentItems', 'parentPhone'],
  data () {
    const isEMAIL = (rule, value, callback) => {
      if (value) {
        if (!this.formDefaultRules.isEMAIL.test(value)) {
          return callback(new Error('输入的电子邮箱不符合规则'));
        }
      }
      return callback();
    };
    const isPHONE = (rule, value, callback) => {
      if (value) {
        if (!this.formDefaultRules.isPHONE.test(value)) {
          return callback(new Error('输入的手机号不符合规则'));
        }
      }
      return callback();
    };
    return {
      formItems: [
        {
          label: '姓名',
          name: 'name',
          readonly: false,
          component: 'input',
          rules: [{required: true, message: '姓名不能为空', trigger: 'blur'}]
        },
        {
          label: '移动电话',
          name: 'phone',
          readonly: false,
          component: 'input',
          rules: [{required: true, message: '移动电话不可为空', trigger: 'blur'}, {validator: isPHONE, trigger: 'blur'}]
        },
        {
          label: '身份证号',
          name: 'idCard',
          readonly: false,
          component: 'input'
        },
        {
          label: '电子信箱一',
          name: 'email1',
          readonly: false,
          component: 'input',
          rules: [{validator: isEMAIL, trigger: 'blur'}]
        },
        {
          label: '电子信箱二',
          name: 'email2',
          readonly: false,
          component: 'input',
          rules: [{validator: isEMAIL, trigger: 'blur'}]
        },
        {
          label: '工作单位代码',
          name: 'orgCode',
          readonly: this.dialogFrom === 'unit',
          component: 'input',
          placeholder: '学校请填学校代码，其它单位请填组织代码，不知请填0'
          // rules: [{required: true, message: '工作单位代码不能为空', trigger: 'blur'}]
        },
        {
          label: '工作单位名称',
          name: 'orgName',
          readonly: this.dialogFrom === 'unit',
          component: 'input'
          // rules: [{required: true, message: '工作单位不能为空', trigger: 'blur'}]
        },
        {
          label: '一级学科',
          name: 'mFirstSubjectCode',
          labelname: 'mFirstSubjectName',
          readonly: false,
          component: 'select',
          options: []
          // rules: [{required: true, message: '一级学科不可为空', trigger: 'change'}]
        },
        {
          label: '二级学科',
          name: 'mSecondSubjectCode',
          labelname: 'mSecondSubjectName',
          readonly: false,
          component: 'select',
          options: []
          // rules: [{required: true, trigger: 'blur'}]
        },
        {
          label: '研究方向',
          name: 'researchAreaOne',
          readonly: false,
          component: 'input'
          // rules: [{required: true, message: '研究方向不可为空', trigger: 'blur'}]
        },
        {
          label: '指导学生类别',
          name: 'studentType',
          readonly: false,
          component: 'select',
          options: [{
            label: '专业学位',
            value: '专业学位'
          }, {
            value: '学术学位',
            label: '学术学位'
          }]
          // rules: [{required: true, message: '指导学生类别不可为空', trigger: 'change'}]
        },
        {
          label: '导师类别',
          name: 'acTutorType',
          readonly: false,
          component: 'select',
          options: []
          // rules: [{required: true, message: '导师类别不可为空', trigger: 'change'}]
        },
        {
          label: '职称',
          name: 'techPosition',
          readonly: false,
          component: 'select',
          options: []
          // rules: [{required: true, message: '职称不可为空', trigger: 'change'}]
        },
        {
          label: '邮政编码',
          name: 'postalCode',
          readonly: false,
          component: 'input'
          // rules: [{required: true, message: '邮政编码不可为空', trigger: 'blur'}]
        }, {
          label: '通讯地址',
          name: 'postalAddr',
          readonly: false,
          component: 'input'
          // rules: [{required: true, message: '通讯地址不可为空', trigger: 'blur'}]
        },
        {
          label: '办公电话',
          name: 'tel',
          readonly: false,
          component: 'input'
        },
        {
          label: '银行卡开户省份',
          name: 'bankProvince',
          labelname: 'bankProvince',
          readonly: false,
          component: 'select',
          options: []
          // rules: [{required: true, message: '银行卡开户省份不可为空', trigger: 'change'}]
        },
        {
          label: '开户银行',
          name: 'bankName',
          labelname: 'bankName',
          readonly: false,
          component: 'select',
          options: []
          // rules: [{required: true, message: '开户银行不可为空', trigger: 'change'}]
        },
        {
          label: '开户行支行',
          name: 'branch',
          labelname: 'branch',
          readonly: false,
          component: 'input'
        },
        {
          label: '银行卡号',
          name: 'bankCardCode',
          readonly: false,
          component: 'input'
          // rules: [{required: true, message: '卡号不可为空', trigger: 'blur'}]
        },
        {
          label: '备注',
          name: 'infoComment',
          readonly: false,
          component: 'input'
        }
      ],
      baseProvinceList: [],
      baseBankList: [],
      formDefaultRules: {},
      BaseConfig: {},
      // 原来的专家信息
      defaultExpertInfo: {},
      // 专家信息
      expertInfo: {},
      loading: false,
      isDisabled: false
    }
  },
  created: function () {
    /* global BaseConfig:true */
    this.BaseConfig = BaseConfig
    /* global FormItemRules:true */
    this.formDefaultRules = FormItemRules;
    this.fetchProList();
    this.fetchBankList();
    // 如果是弹窗
    if (this.dialog) {
      this.expertInfo = Object.compare(this.expertInfo, this.info);
      this.defaultExpertInfo = {...this.expertInfo};
      // 初始化指导学生类别
      this.initStudentType();
      // 如果是只读
      if (this.readonly) {
        // 翻译编码字段
        this.translateName();
      } else {
        this.initOptionList();
        this.getAllFirstSubject('/conf/confFirstSubject/all', 'mFirstSubjectCode');// 获取一级学科列表
        this.changeOnSelect({name: 'mFirstSubjectCode'}); // 获取二级学科列表
      }
    } else {
      // 评阅页面专家注册
      if (this.parentItems) {
        this.formItems = this.parentItems
        this.expertInfo.phone = this.parentPhone
        this.initOptionList();
        this.getAllFirstSubject('/expReviewCodeLogin/firstSubjectAll', 'mFirstSubjectCode');// 获取一级学科列表
        // 新增内容，不需要去触发二级列表
      } else {
        // 个人信息查看
        const isEMAIL = (rule, value, callback) => {
          if (value) {
            if (!this.formDefaultRules.isEMAIL.test(value)) {
              return callback(new Error('输入的电子邮箱不符合规则'));
            }
          }
          return callback();
        };
        // 重置显示字段
        this.formItems = [
          {
            isTitle: true,
            label: '联系信息'
          },
          {
            label: '身份证号',
            name: 'idCard',
            readonly: false,
            component: 'input',
            rules: [{required: true, message: '身份证号不能为空', trigger: 'blur'}]
          },
          {
            label: '银行卡开户省份',
            name: 'bankProvince',
            labelname: 'bankProvince',
            readonly: false,
            component: 'select',
            options: [],
            rules: [{required: true, message: '银行卡开户省份不可为空', trigger: 'change'}]
            // rules: [{required: true, trigger: 'blur'}]
          },
          {
            label: '开户银行',
            name: 'bankName',
            labelname: 'bankName',
            readonly: false,
            component: 'select',
            options: [],
            rules: [{required: true, message: '开户银行不可为空', trigger: 'change'}]
            // rules: [{required: true, trigger: 'blur'}]
          },
          {
            label: '开户行支行',
            name: 'branch',
            labelname: 'branch',
            readonly: false,
            component: 'input',
            rules: [{required: true, message: '开户行支行不可为空', trigger: 'blur'}]
          },
          {
            label: '银行卡号',
            name: 'bankCardCode',
            readonly: false,
            component: 'input',
            rules: [{required: true, message: '卡号不可为空', trigger: 'blur'}]
          },
          {
            label: '移动电话',
            name: 'phone',
            readonly: false,
            component: 'phone'
          },
          {
            label: '办公电话',
            name: 'tel',
            readonly: false,
            component: 'input'
          }, {
            label: '工作单位代码',
            name: 'orgCode',
            readonly: false,
            component: 'input',
            placeholder: '学校请填学校代码，其它单位请填组织代码，不知请填0',
            rules: [{required: true, message: '工作单位代码不能为空', trigger: 'blur'}]
          },
          {
            label: '工作单位',
            name: 'orgName',
            readonly: false,
            component: 'input',
            rules: [{required: true, message: '工作单位不能为空', trigger: 'blur'}]
          },
          {
            label: '一级学科',
            name: 'mFirstSubjectCode',
            labelname: 'mFirstSubjectName',
            readonly: false,
            component: 'select',
            options: [],
            rules: [{required: true, message: '一级学科不可为空', trigger: 'change'}]
          },
          {
            label: '二级学科',
            name: 'mSecondSubjectCode',
            labelname: 'mSecondSubjectName',
            readonly: false,
            component: 'select',
            options: []
            // rules: [{required: true, trigger: 'blur'}]
          },
          {
            label: '研究方向',
            name: 'researchAreaOne',
            readonly: false,
            component: 'input',
            rules: [{required: true, message: '研究方向不可为空', trigger: 'blur'}]
          },
          {
            label: '指导学生类别',
            name: 'studentType',
            readonly: false,
            component: 'select',
            options: [{
              label: '专业学位',
              value: '专业学位'
            },
            {
              value: '学术学位',
              label: '学术学位'
            }],
            rules: [{required: true, message: '指导学生类别不可为空', trigger: 'change'}]
          },
          {
            label: '导师类别',
            name: 'acTutorType',
            readonly: false,
            component: 'select',
            options: [],
            rules: [{required: true, message: '导师类别不可为空', trigger: 'change'}]
          },
          {
            label: '职称',
            name: 'techPosition',
            readonly: false,
            component: 'select',
            options: [],
            rules: [{required: true, message: '职称不可为空', trigger: 'change'}]
          },
          {
            label: '电子信箱一',
            name: 'email1',
            readonly: false,
            component: 'input',
            rules: [{required: true, message: '电子信箱一不可为空', trigger: 'blur'}, {validator: isEMAIL, trigger: 'blur'}]
          },
          {
            label: '电子信箱二',
            name: 'email2',
            readonly: false,
            component: 'input',
            rules: [{validator: isEMAIL, trigger: 'blur'}]
          },
          {
            label: '邮政编码',
            name: 'postalCode',
            readonly: false,
            component: 'input'
            // rules: [{required: true, message: '邮政编码不可为空', trigger: 'blur'}]
          }, {
            label: '通讯地址',
            name: 'postalAddr',
            readonly: false,
            component: 'input'
            // rules: [{required: true, message: '通讯地址不可为空', trigger: 'blur'}]
          }, {
            label: '备注',
            name: 'infoComment',
            readonly: false,
            component: 'input'
          }
        ]
        this.initOptionList();
        this.getAllFirstSubject('/conf/confFirstSubject/all', 'mFirstSubjectCode');// 获取一级学科列表
        this.fetchExpertInfoByUserId();
      }
    }
  },
  mounted: function () {
  },
  methods: {
    handleBlur () {
      if (!this.formDefaultRules.isPHONE.test(this.expertInfo.phone)) {
        this.$Message.error('请输入符合规则的手机号查询信息')
      } else {
        this.fetch(`exp/expInfo/queryExpByPhone`, {phone: this.expertInfo.phone}).then(res => {
          if (res.data) {
            this.expertInfo = res.data
            this.readonly = true
          }
        })
      }
    },
    // 动态加载组件
    getDisplayComponent (display) {
      return 'Element' + display.replace(display.charAt(0), display.charAt(0).toUpperCase());
    },
    // 获取身份列表
    fetchProList () {
      const _self = this;
      _self.post('/conf/confProvince/list').then(res => {
        _self.baseProvinceList = res.data
        if (_self.readonly) {
          _self.expertInfo.bankProvince = (_self.baseProvinceList.filter(item => item.id === _self.expertInfo.bankProvince)[0] || {mc: _self.expertInfo.bankProvince}).mc
        } else {
          _self.formItems.forEach(element => {
            if (element.name === 'bankProvince') {
              for (let option of res.data) {
                element.options.push({
                  id: option.id,
                  value: option.id,
                  label: option.mc
                });
              }
            }
          });
        }
      })
    },
    // 获取银行列表
    fetchBankList () {
      const _self = this;
      _self.post('/conf/confBank/list').then(res => {
        _self.baseBankList = res.data;
        if (_self.readonly) {
          _self.expertInfo.bankName = (_self.baseBankList.filter(item => item.id === _self.expertInfo.bankName)[0] || {mc: _self.expertInfo.bankName}).mc
        } else {
          _self.formItems.forEach(element => {
            if (element.name === 'bankName') {
              element.options = []
              for (let option of res.data) {
                element.options.push({
                  id: option.id,
                  value: option.id,
                  label: option.mc
                });
              }
            }
          });
        }
      })
    },
    // 从数据库获取一级学科集合或门类集合
    getAllFirstSubject (url, name) {
      const _self = this;
      _self.post(url, {type: 1}).then(res => {
        // 一级学科
        _self.formItems.forEach(element => {
          if (element.name === name) {
            for (let option of res.data) {
              element.options.push({
                id: option.id,
                value: option.code,
                label: option.name
              });
            }
          }
        });
      });
    },
    // 翻译字段code->中文name
    translateName () {
      const _self = this;
      _self.expertInfo.nation = ((_self.BaseConfig.gj.filter(item => item[0] === this.expertInfo.nation))[0] || ['1', this.expertInfo.nation])[1];
      _self.expertInfo.sex = ((_self.BaseConfig.sex.filter(item => item[0] === this.expertInfo.sex))[0] || ['1', this.expertInfo.sex])[1];
      _self.expertInfo.fHrRelLocal = ((_self.BaseConfig.sf.filter(item => item[0] === this.expertInfo.fHrRelLocal))[0] || ['1', this.expertInfo.fHrRelLocal])[1];
      _self.expertInfo.fHrDegSame = ((_self.BaseConfig.sf.filter(item => item[0] === this.expertInfo.fHrDegSame))[0] || ['1', this.expertInfo.fHrDegSame])[1];
      _self.expertInfo.idCardType = ((_self.BaseConfig.zjzl.filter(item => item[0] === this.expertInfo.idCardType))[0] || ['1', this.expertInfo.idCardType])[1];
      _self.expertInfo.degree = ((_self.BaseConfig.xw.filter(item => item[0] === this.expertInfo.degree))[0] || ['1', this.expertInfo.degree])[1];
      _self.expertInfo.techPosition = ((_self.BaseConfig.zyjszw.filter(item => item[0] === this.expertInfo.techPosition))[0] || ['1', this.expertInfo.techPosition])[1];
      _self.expertInfo.acTutorType = ((_self.BaseConfig.dslb.filter(item => item[0] === this.expertInfo.acTutorType))[0] || ['1', this.expertInfo.acTutorType])[1];
      _self.expertInfo.proTutorType = ((_self.BaseConfig.dslb.filter(item => item[0] === this.expertInfo.proTutorType))[0] || ['1', this.expertInfo.proTutorType])[1];
      _self.expertInfo.lngType = ((_self.BaseConfig.wgyz.filter(item => item[0] === this.expertInfo.lngType))[0] || ['1', this.expertInfo.lngType])[1];
      _self.expertInfo.lngLevel = ((_self.BaseConfig.wyslcd.filter(item => item[0] === this.expertInfo.lngLevel))[0] || ['1', this.expertInfo.lngLevel])[1];
      _self.expertInfo.expType = ((_self.BaseConfig.zjlb.filter(item => item[0] === this.expertInfo.expType))[0] || ['1', this.expertInfo.expType])[1];
    },
    // 初始化下拉框选项
    initOptionList () {
      const _self = this;
      // 导师类别
      let index = _self.formItems.findIndex(el => el.name === 'acTutorType');
      if (index >= 0) {
        this.formItems[index].options = [];
        for (let option of _self.BaseConfig.dslb) {
          _self.formItems[index].options.push({
            value: option[0],
            label: option[1]
          })
        }
      }

      // 专业学位导师类别
      index = _self.formItems.findIndex(el => el.name === 'proTutorType');
      if (index >= 0) {
        this.formItems[index].options = [];
        for (let option of _self.BaseConfig.dslb) {
          _self.formItems[index].options.push({
            value: option[0],
            label: option[1]
          })
        }
      }

      // 国际
      index = _self.formItems.findIndex(el => el.name === 'nation');
      if (index >= 0) {
        this.formItems[index].options = [];
        for (let option of _self.BaseConfig.gj) {
          _self.formItems[index].options.push({
            value: option[0],
            label: option[1]
          })
        }
      }
      // 性别
      index = _self.formItems.findIndex(el => el.name === 'sex');
      if (index >= 0) {
        this.formItems[index].options = [];
        for (let option of _self.BaseConfig.sex) {
          _self.formItems[index].options.push({
            value: option[0],
            label: option[1]
          })
        }
      }

      // 证件类型
      index = _self.formItems.findIndex(el => el.name === 'idCardType');
      if (index >= 0) {
        this.formItems[index].options = [];
        for (let option of _self.BaseConfig.zjzl) {
          _self.formItems[index].options.push({
            value: option[0],
            label: option[1]
          })
        }
      }

      // 人事关系是否在本校
      index = _self.formItems.findIndex(el => el.name === 'fHrRelLocal');
      if (index >= 0) {
        this.formItems[index].options = [];
        for (let option of _self.BaseConfig.sf) {
          _self.formItems[index].options.push({
            value: option[0],
            label: option[1]
          })
        }
      }

      // 人事关系所在单位是否学位授予单位
      index = _self.formItems.findIndex(el => el.name === 'fHrDegSame');
      if (index >= 0) {
        this.formItems[index].options = [];
        for (let option of _self.BaseConfig.sf) {
          _self.formItems[index].options.push({
            value: option[0],
            label: option[1]
          })
        }
      }

      // 最高学位
      index = _self.formItems.findIndex(el => el.name === 'degree');
      if (index >= 0) {
        this.formItems[index].options = [];
        for (let option of _self.BaseConfig.xw) {
          _self.formItems[index].options.push({
            value: option[0],
            label: option[1]
          })
        }
      }

      // 职称
      index = _self.formItems.findIndex(el => el.name === 'techPosition');
      if (index >= 0) {
        this.formItems[index].options = [];
        for (let option of _self.BaseConfig.zyjszw) {
          _self.formItems[index].options.push({
            value: option[0],
            label: option[1]
          })
        }
      }

      // 外国语种名称
      index = _self.formItems.findIndex(el => el.name === 'lngType');
      if (index >= 0) {
        this.formItems[index].options = [];
        for (let option of _self.BaseConfig.wgyz) {
          _self.formItems[index].options.push({
            value: option[0],
            label: option[1]
          })
        }
      }

      // 外语熟练程度
      index = _self.formItems.findIndex(el => el.name === 'lngLevel');
      if (index >= 0) {
        this.formItems[index].options = [];
        for (let option of _self.BaseConfig.wyslcd) {
          _self.formItems[index].options.push({
            value: option[0],
            label: option[1]
          })
        }
      }

      // 专家类别
      index = _self.formItems.findIndex(el => el.name === 'expType');
      if (index >= 0) {
        this.formItems[index].options = [];
        for (let option of _self.BaseConfig.zjlb) {
          _self.formItems[index].options.push({
            value: option[0],
            label: option[1]
          })
        }
      }
    },
    // 初始化指导学生类别
    initStudentType () {
      const _self = this;
      if (_self.expertInfo.acTutorType && _self.expertInfo.acTutorType !== '-1') {
        _self.expertInfo.studentType = '学术学位'
      } else if (_self.expertInfo.proTutorType && _self.expertInfo.proTutorType !== '-1') {
        _self.expertInfo.acTutorType = _self.expertInfo.proTutorType
        _self.expertInfo.studentType = '专业学位'
      }
    },
    // 选择框关联时做联动
    changeOnSelect (item) {
      const _self = this
      // if (!_self.dialog && item.name === 'studentType') {
      //   _self.fetch('/exp/expInfo/info/getExpByUserId').then(res => {
      //     if (_self.expertInfo.studentType === '学术学位') {
      //       _self.expertInfo.acTutorType = res.data.acTutorType
      //     }
      //     if (_self.expertInfo.studentType === '专业学位') {
      //       _self.expertInfo.acTutorType = res.data.proTutorType
      //     }
      //   });
      // }
      // 主要一级学科change
      if (item.name === 'mFirstSubjectCode') {
        let index = _self.formItems.findIndex(el => el.name === 'mSecondSubjectCode');
        _self.formItems[index].options = [];
        if (_self.expertInfo.mFirstSubjectCode) {
          _self.post('/conf/confSecondSubject/query', {code: _self.expertInfo.mFirstSubjectCode}).then(res => {
            let isExist = false;
            for (let option of res.data) {
              if (_self.expertInfo.mSecondSubjectCode === option.code) isExist = true;
              _self.formItems[index].options.push({
                id: option.id,
                value: option.code,
                label: option.name
              });
            }
            if (!isExist) {
              _self.expertInfo.mSecondSubjectCode = '';
              _self.expertInfo.mSecondSubjectName = '';
            }
          });
        }
      }
      // 专业一级学科change
      if (item.name === 'firstSubjectCode') {
        let index = _self.formItems.findIndex(el => el.name === 'secondSubjectCode');
        _self.formItems[index].options = [];
        if (_self.expertInfo.firstSubjectCode) {
          _self.post('/conf/confSecondSubject/query', {code: _self.expertInfo.firstSubjectCode}).then(res => {
            let isExist = false;
            for (let option of res.data) {
              if (_self.expertInfo.secondSubjectCode === option.code) isExist = true;
              _self.formItems[index].options.push({
                id: option.id,
                value: option.code,
                label: option.name
              });
            }
            if (!isExist) {
              _self.expertInfo.secondSubjectCode = '';
              _self.expertInfo.secondSubjectName = '';
            }
          });
        }
      }
      // 学位类型change
      if (item.name === 'degreeCategoryCode') {
        let index = _self.formItems.findIndex(el => el.name === 'degreeDomainCode');
        _self.formItems[index].options = [];
        if (_self.expertInfo.degreeCategoryCode) {
          _self.post('/conf/confSecondSubject/query', {code: _self.expertInfo.degreeCategoryCode}).then(res => {
            let isExist = false;
            for (let option of res.data) {
              if (_self.expertInfo.degreeDomainCode === option.code) isExist = true;
              _self.formItems[index].options.push({
                id: option.id,
                value: option.code,
                label: option.name
              });
            }
            if (!isExist) {
              _self.expertInfo.degreeDomainCode = '';
              _self.expertInfo.degreeDomainName = '';
            }
          });
        }
      }
    },
    // input change
    changeInput (item) {
      const _self = this;
      if (item.name === 'phone') {
        if (_self.formDefaultRules.isPHONE.test(_self.expertInfo.phone)) {
          _self.fetch('/exp/expInfo/queryExpByPhone', {phone: _self.expertInfo.phone}).then(res => {
            if (res.data) {
              _self.$Modal.confirm({
                title: '提示',
                width: 340,
                content: '系统专家库已有该数据，是否读取专家库信息？',
                onOk: function () {
                  _self.expertInfo = Object.assign(_self.expertInfo, res.data);
                },
                onCancel: function () {
                }
              })
            }
          }).catch(() => {
          });
        }
      }
    },
    // 改变code的同时，改变name值
    changeOnSelectForLabel (name, value) {
      // 判断name是否存在
      if (name) {
        this.expertInfo[name] = value;
      }
    },
    // 通过userId查询自己的个人信息（角色是专家）
    fetchExpertInfoByUserId () {
      const _self = this
      _self.fetch('/exp/expInfo/info/getExpByUserId').then(res => {
        _self.defaultExpertInfo = {...res.data};
        _self.expertInfo = res.data;
        if (_self.expertInfo.acTutorType && _self.expertInfo.acTutorType !== '-1') {
          _self.expertInfo.acTutorType = res.data.acTutorType
          _self.expertInfo.studentType = '学术学位'
        } else if (_self.expertInfo.proTutorType && _self.expertInfo.proTutorType !== '-1') {
          _self.expertInfo.acTutorType = res.data.proTutorType
          _self.expertInfo.studentType = '专业学位'
        }
        _self.changeOnSelect({name: 'mFirstSubjectCode'});
      });
    },
    // 表单验证方法
    validate () {
      const _self = this;
      return _self.$refs['thesisEditForm'].validate((valid) => {
        if (valid) {
          if (_self.expertInfo.studentType) {
            let tutorType = _self.expertInfo.acTutorType
            if (_self.expertInfo.studentType === '专业学位') {
              _self.expertInfo.proTutorType = tutorType
              _self.expertInfo.acTutorType = '-1'
            }
            if (_self.expertInfo.studentType === '学术学位') {
              _self.expertInfo.acTutorType = tutorType
              _self.expertInfo.proTutorType = '-1'
            }
          }
          delete _self.expertInfo.studentType;
          return _self.expertInfo;
        } else {
          return false;
        }
      })
    },
    // 保存专家个人信息
    saveExpInfo () {
      const _self = this;
      _self.validate().then(res => {
        if (res) {
          if (_self.expertInfo.studentType) {
            let tutorType = _self.expertInfo.acTutorType
            if (_self.expertInfo.studentType === '专业学位') {
              _self.expertInfo.proTutorType = tutorType
              _self.expertInfo.acTutorType = '-1'
            }
            if (_self.expertInfo.studentType === '学术学位') {
              _self.expertInfo.acTutorType = tutorType
              _self.expertInfo.proTutorType = '-1'
            }
          }
          let params = Object.compare(_self.defaultExpertInfo, _self.expertInfo);
          if (params.studentType) {
            delete params.studentType
          }
          if (_self.defaultExpertInfo.id) {
            params.id = _self.defaultExpertInfo.id;
          }
          _self.post('/exp/expInfo/saveOrUpdate', params).then(res => {
            if (res.code === 200) {
              _self.$Message.success('保存成功');
              if (this.$route.query.back === '1') {
                this.$router.go(-1)
              } else {
                this.fetchExpertInfoByUserId();
              }
            }
          })
        }
      });
    }
  }
}
</script>

<style lang="less">
  .expert-info {
    .expType{
      width:100%!important
    }
    .form-label {
      color: #515a6e;
      display: block;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .kh-date-picker{
      width: 100%;
    }
    .kh-form-item{
      width: 48%;
    }
    .form-item-online{
      width: 98% !important;
    }
    .kh-form-item-error-tip {
      right: 25px;
    }
  }
</style>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/layout/customPage/expertManage/expertInfo.vue